import { render, staticRenderFns } from "./DialogDelete.vue?vue&type=template&id=bbf9a87a"
import script from "./DialogDelete.vue?vue&type=script&lang=js"
export * from "./DialogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf9a87a')) {
      api.createRecord('bbf9a87a', component.options)
    } else {
      api.reload('bbf9a87a', component.options)
    }
    module.hot.accept("./DialogDelete.vue?vue&type=template&id=bbf9a87a", function () {
      api.rerender('bbf9a87a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogDelete.vue"
export default component.exports